import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The muted round icon badge used by every empty, error and placeholder state.
 * Extracted because three files had drawn it independently.
 */
export function IconCircle({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('grid size-11 place-items-center rounded-full bg-surface-2 text-muted', className)}>
      {children}
    </div>
  );
}
